import { muiComponentsMenusPopover } from './muiComponentsMenusPopover'
import { muiComponentsMenusItems } from './muiComponentsMenusItems'

export const muiComponentsMenus = {
  ...muiComponentsMenusPopover,
  ...muiComponentsMenusItems,
}
